module.exports = __webpack_public_path__ + "static/media/logo_dark_small.285096b5.png";